export default __webpack_public_path__ + "static/media/PPI-steps-013.8f2cc522.jpg";